'use client'

import CardPlacingOrder from '@/entities/cart-page/CardPlacingOrder'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser'
import {
    changePaymentMethodValue,
    fetchConfirm,
} from '@/shared/store/slice/cartSlice'
import { useEffect, useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { redirect } from 'next/navigation'
import { getModulBankData } from '@/shared/store/slice/cartSlice'
import api from '@/shared/api'
import classNames from 'classnames'
import { changeCurrentStep } from '@/shared/store/slice/cartSlice'
import { IoCheckmarkSharp } from "react-icons/io5";
import { IoInformationCircleOutline } from "react-icons/io5";
import Link from 'next/link'

export const Confirm = () => {
    const [comment, setComment] = useState('')

    const { userAuth, userInfo } = useGetIsAuthUser()

    const dispatch = useDispatch()

    const navigate = (path) => redirect(path)

    const [go, setGo] = useState(false)

    const [agreement1, setAgreement1] = useState(false)
    const [agreement2, setAgreement2] = useState(false)

    const {
        currentStep: step,
        isOrderConfirm,
        paymentMethodValue,
        modulBankData,
    } = useSelector((state) => state.cartActions)

    const confirmHandler = () => {
        let error = ''
        if (document.getElementById('cart-customer-name').value == '')
            error += 'Не указано имя\n'
        if (document.getElementById('cart-customer-lastName').value == '')
            error += 'Не указана фамилия\n'
        if (document.getElementById('cart-customer-email').value == '')
            error += 'Не указано Email\n'
        if (document.getElementById('cart-customer-phone').value == '')
            error += 'Не указано телефон\n'
        if (document.getElementById('cart-customer-address') != undefined) {
            if (document.getElementById('cart-customer-address').value == '')
                error += 'Не указан адрес\n'
        }

        if (error != '') {
            alert(error)
            dispatch(changeCurrentStep(4))
        } else {
            setGo(true)

            dispatch(
                fetchConfirm({
                    comment: comment,
                    user_id: userAuth ? userInfo.id : 0,
                    userInfo,
                })
            )

            if (paymentMethodValue == 'modulbank') {
                dispatch(getModulBankData())
            } else if (paymentMethodValue == 'yoomoney') {
                // Юкасса — запрос к /send
                api.get(`index.php?route=payment/${paymentMethodValue}/send`)
                    .then((res) => {
                        if (res?.data?.redirect) {
                            window.location.href = res.data.redirect
                        } else {
                            navigate('/success')
                        }
                    })
            } else {
                // cheque, bank_transfer и другие
                api.get(`index.php?route=payment/${paymentMethodValue}/confirm`)
                    .then((res) => navigate('/success'))
            }
        }
    }

    useEffect(() => {
        if (go) {
            setGo(false)

            if (modulBankData) {
                dispatch(changeCurrentStep(3))
                dispatch(changePaymentMethodValue(null))

                if (modulBankData.error) {
                    return
                }
                const formData = new FormData()
                const hiddenForm = document.createElement('form')
                hiddenForm.method = 'post'
                hiddenForm.action = 'https://pay.modulbank.ru/pay'
                for (let key in modulBankData.fields) {
                    formData.append(key, modulBankData.fields[key])
                }

                for (var pair of formData.entries()) {
                    var input = document.createElement('input')
                    input.type = 'hidden'
                    input.name = pair[0]
                    input.value = pair[1]
                    hiddenForm.appendChild(input)
                }

                document.body.appendChild(hiddenForm)
                hiddenForm.submit()
            }
        }
    }, [modulBankData])

    return (
        <CardPlacingOrder
            stepTitle={'Шаг 5: Комментарий к заказу'}
            currentStep={step === 5}
            changeStep={confirmHandler}
            className={classNames(
                'big-card position-relative',
                step < 5 ? 'disabled-step' : ''
            )}
            textButton={'Перейти к оплате'}
            isValid={agreement1 && agreement2}
        >
            <InputGroup className={'flex-column align-items-start gap-1 w-100'}>
                <label>Комментарий</label>
                <Form.Control
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    className={'p-3 w-100'}
                />
            </InputGroup>

            {/* Блок уведомления об отмене заказа — под полем комментария */}
            <div style={{
                background: '#f8f9fa',
                borderLeft: '3px solid #6c757d',
                borderRadius: '4px',
                padding: '12px 16px',
                marginTop: '16px',
                marginBottom: '20px'
            }}>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                    <IoInformationCircleOutline size={18} style={{ color: '#6c757d', marginTop: '2px', flexShrink: 0 }} />
                    <div style={{ fontSize: '14px', color: '#555', lineHeight: '1.6' }}>
                        <p style={{ margin: '0 0 8px 0', fontWeight: '500', color: '#333' }}>
                            Условия отмены и возврата
                        </p>
                        <ul style={{ margin: 0, paddingLeft: '16px' }}>
                            <li>До отправки заказа — отмена через личный кабинет, полный возврат без удержаний.</li>
                            <li>После отправки — отмена через ЛК недоступна. Возврат возможен только после поступления заказа в ПВЗ, с удержанием стоимости доставки.</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className={'d-flex gap-2 flex-column'}>
                <div className='d-flex gap-2'>
                    <div
                        className={classNames(
                            'border border-black d-flex align-items-center justify-content-center',
                            agreement1 ? 'bg-black text-white' : ''
                        )}
                        style={{ width: '22px', height: '22px' }}
                        onClick={() => setAgreement1(prev => !prev)}
                    >
                        {agreement1 && <IoCheckmarkSharp />}
                    </div>
                    <p>Оформляя заказ, я соглашаюсь на обработку персональных данных в соответствии с 
                        <Link className='text-black' style={{ textDecoration: 'underline', marginLeft: '5px' }} href={'/politika-obrabotki-personalnyx-dannyx'}>Политикой конфиденциальности</Link>
                    </p>
                </div>
                <div className='d-flex gap-2'>
                    <div
                        className={classNames(
                            'border border-black d-flex align-items-center justify-content-center',
                            agreement2 ? 'bg-black text-white' : ''
                        )}
                        style={{ width: '22px', height: '22px' }}
                        onClick={() => setAgreement2(prev => !prev)}
                    >
                        {agreement2 && <IoCheckmarkSharp />}
                    </div>
                    <p>Соглашаюсь с 
                        <Link className='text-black' style={{ textDecoration: 'underline', marginInline: '5px' }} href={'/pravilami-polzovanija-torgovoj-ploschadkoj'}>правилами пользования торговой площадки</Link>
                        и
                        <Link className='text-black' style={{ textDecoration: 'underline', marginLeft: '5px' }} href={'/dokumenty'}>возврата</Link>
                    </p>
                </div>
            </div>
        </CardPlacingOrder>
    )
}